var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgId(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9375 6.71875L18.9688 6.46875C19.0312 6.21875 18.8438 6 18.5938 6H15.5312L16.1562 2.46875C16.2188 2.21875 16.0312 2 15.7812 2H15.5312C15.375 2 15.1875 2.15625 15.1562 2.3125L14.5 6H10.5312L11.1562 2.46875C11.2188 2.21875 11.0312 2 10.7812 2H10.5312C10.375 2 10.1875 2.15625 10.1562 2.3125L9.5 6H6.3125C6.125 6 5.96875 6.15625 5.9375 6.3125L5.875 6.5625C5.84375 6.8125 6.03125 7 6.25 7H9.34375L8.625 11H5.40625C5.21875 11 5.0625 11.1562 5.03125 11.3125L5 11.5625C4.9375 11.8125 5.125 12 5.375 12H8.4375L7.8125 15.5625C7.75 15.8125 7.9375 16 8.1875 16H8.4375C8.59375 16 8.78125 15.875 8.8125 15.7188L9.46875 12H13.4375L12.8125 15.5625C12.75 15.8125 12.9375 16 13.1875 16H13.4375C13.5938 16 13.7812 15.875 13.8125 15.7188L14.4688 12H17.6562C17.8438 12 18 11.875 18.0312 11.7188L18.0938 11.4688C18.125 11.2188 17.9375 11 17.7188 11H14.625L15.3438 7H18.5625C18.75 7 18.9062 6.875 18.9375 6.71875ZM13.625 11H9.625L10.3438 7H14.3438L13.625 11Z",
    fill: "#6C757D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgId);
export default __webpack_public_path__ + "static/media/id.2ee0c3a8.svg";
export { ForwardRef as ReactComponent };